const WEATHER = {
  LOADING: 'WEATHER_LOADING',
  FETCH_SUCCESS: 'WEATHER_FETCH_SUCCESS',
  FETCH_FAILED: 'WEATHER_FETCH_FAILED',
};

export { WEATHER };
